<template>
  <div :class="{ 'h-24 load load--fill': loading }">
    <div v-if="authorized">
      <Breadcrumbs
        v-if="folderHasContents && !loading"
        :current-folder="folder.attributes.title"
        :current-folder-uuid="folderUuid"
        :shared-item-mode="false"
        :ancestors="ancestors"
      />
      <div
        v-if="folderHasContents && !loading"
        class="table-responsive"
      >
        <table class="table table-files min-w-table">
          <thead>
            <tr>
              <th
                colspan="8"
                class="table-caption"
              >
                <FolderActions
                  v-can="'edit-documents'"
                  :folder="folder"
                />
                <h2 v-html="folder.attributes.title" />
              </th>
            </tr>
            <tr>
              <th />
              <th />
              <th v-text="'Name'" />
              <th v-text="'Modified'" />
              <th
                v-can="'edit-documents'"
                v-text="'Visibility'"
              />
              <th
                v-can="'edit-documents'"
                v-text="'Organizations'"
              />
              <th />
              <th v-can="'edit-documents'" />
            </tr>
          </thead>
          <tbody>
            <tr
              is="FolderRow"
              v-for="childFolder in childFolders"
              :key="childFolder.uuid"
              :folder="childFolder"
            />
            <tr
              is="DocumentRow"
              v-for="document in documents"
              :key="document.uuid"
              :document="document"
            />
          </tbody>
        </table>
      </div>
      <div
        v-if="!folderHasContents && !loading"
        class="text-center py-12 flex justify-center items-center my-4 border border-grey-darker rounded shadow"
      >
        <div class="">
          <h1
            class="mb-8"
            v-text="'This folder is empty'"
          />
          <a
            href="#"
            class="btn ml-auto mb-6"
            @click.prevent="$store.commit('documentOpenUploadDocumentModal', folder.uuid)"
            v-text="'Add Documents'"
          />
          <div class="mt-12">
            <FolderActions
              v-can="'edit-documents'"
              :folder="folder"
            />
          </div>
        </div>
      </div>
      <EditFolderModal @folderHasBeenUpdated="fetch" />
      <EditDocumentModal @documentHasBeenUpdated="fetch" />
      <DeleteFolderModal />
      <DeleteDocumentModal />
      <MoveDocumentModal />
      <ReplaceDocumentModal />
      <DocumentHistoryModal />
      <SendToMembershipGroupsModal
        :shared-item-mode="false"
        @resourceHasBeenSentToMembershipGroups="fetch"
      />
      <SendToMembershipsModal
        :shared-item-mode="false"
        @resourceHasBeenSentToMemberships="fetch"
      />
      <SendToOrganizationsModal />
      <CreateFolderModal
        :parent-folder-uuid="folderUuid"
        @documentFolderHasBeenCreated="fetch"
      />
    </div>
    <div
      v-if="!authorized"
      v-text="'You do not have correct permissions to access this view.'"
    />
  </div>
</template>

<script type="text/babel">
import FolderRow from './FolderRow'
import DocumentRow from './DocumentRow'
import FolderActions from './FolderActions'
import Breadcrumbs from './FolderBreadcrumbs'
import EditFolderModal from './_modals/EditFolderModal'
import CreateFolderModal from './_modals/CreateFolderModal'
import EditDocumentModal from './_modals/EditDocumentModal'
import SendToMembershipGroupsModal from './_modals/SendToMembershipGroupsModal'
import DeleteFolderModal from './_modals/DeleteFolderModal'
import SendToOrganizationsModal from './_modals/SendToOrganizationsModal'
import MoveDocumentModal from './_modals/MoveDocumentModal'
import SendToMembershipsModal from './_modals/SendToMembershipsModal'
import DeleteDocumentModal from './_modals/DeleteDocumentModal'
import ReplaceDocumentModal from './_modals/ReplaceDocumentModal'
import DocumentHistoryModal from './_modals/DocumentHistoryModal'

export default {
  name: 'FolderDetails',
  components: {
    FolderRow,
    Breadcrumbs,
    DocumentRow,
    FolderActions,
    EditFolderModal,
    EditDocumentModal,
    CreateFolderModal,
    SendToMembershipGroupsModal,
    DeleteFolderModal,
    SendToOrganizationsModal,
    MoveDocumentModal,
    SendToMembershipsModal,
    DeleteDocumentModal,
    DocumentHistoryModal,
    ReplaceDocumentModal,
  },
  props: {
    folderUuid: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      loading: false,
      authorized: true,
    }
  },
  computed: {
    folder() {
      return this.$store.state.document.folder
    },
    ancestors() {
      return this.folder.ancestors.data
    },
    childFolders() {
      return this.folder.folders.data
    },
    documents() {
      return this.folder.documents.data
    },
    folderHasContents() {
      return this.folder.documents.data.length || this.folder.folders.data.length
    },
  },
  async mounted() {
    await this.$nextTick()

    this.fetch()
  },
  methods: {
    fetch() {
      this.loading = true

      this.$store.dispatch('documentGetFolderDetails', this.folderUuid)
        .then(() => {
          this.loading = false
        }).catch((errors) => {
          if (errors.response.status === 403) {
            this.loading = false
            this.authorized = false
          }
        })
    },
    openSendToMembershipGroupsModal() {
      this.$store.commit('documentOpenSendToMembershipGroupsModal', this.folder)
    },
    openDeleteFolderModal() {
      this.$store.commit('documentOpenDeleteFolderModal', this.folder)
    },
  },
}
</script>
